import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "addButtonContainer"];

  connect() {
    this.lastFormIndex = this.findLastFormIndex();
  }

  add() {
    this.formTargets.some((formTarget) => {
      const index = parseInt(formTarget.dataset.index, 10);
      if (formTarget.classList.contains("hidden") && this.lastFormIndex < index) {
        formTarget.classList.remove("hidden");
        this.lastFormIndex = index;

        // If there are no more hidden forms, hide the add button container
        if (!this.hasHiddenForms()) {
          this.addButtonContainerTarget.classList.add("hidden");
        }

        return true; // break the loop
      }
    });
  }

  findLastFormIndex() {
    let lastIndex = 0;
    this.formTargets.forEach((formTarget) => {
      const index = parseInt(formTarget.dataset.index, 10);
      // if it doesn't have the hidden class
      if (!formTarget.classList.contains("hidden") && index > lastIndex) {
        lastIndex = index;
      }
    })

    return lastIndex;
  }

  hasHiddenForms() {
    return this.formTargets.some((ft) => ft.classList.contains("hidden"));
  }
}
